<template>
    <div>
        <the-banner :title="this.$lang.aboutTitle"
                    :description="this.$lang.aboutSubtitle"
                    image="cover.jpeg"/>
        <markdown-wrapper class="body-block"
                          id="markdown"
                          :source="markdown"/>
    </div>
</template>

<script>
	import TheBanner from "@/components/TheBanner";
	import AboutService from "@/services/AboutService";
	import MarkdownWrapper from "@/components/MarkdownWrapper";

	export default {
		name: "About",
		components: {MarkdownWrapper, TheBanner},
		data() {
			return {
				markdown: AboutService.contents(),
			};
		}
	}
</script>

<style scoped>

</style>